<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right width="500">
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-avatar>
                        <img :src="img">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">{{ titleName }}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-list class="pt-0" dense flat>
                <v-divider></v-divider>
                <v-card outlined>
                    <v-card-text>
                        <v-text-field
                                v-model="value.name"
                                label="Class Name"
                                autofocus
                        ></v-text-field>

                        <v-checkbox
                                v-if="!value.isAggregateRoot"
                                v-model="value.isVO"
                                label="Is Value Object"
                        ></v-checkbox>

                        <v-text-field
                                v-if="value.isVO"
                                v-model="value.referenceClass"
                                label="Reference Class"
                        ></v-text-field>
                    </v-card-text>
                </v-card>

                <v-card outlined>
                    <v-card-text>
                        <event-storming-attribute
                                v-model="value.fieldDescriptors"
                                :entities="entities"
                                :type="value._type"
                                :elementId="value.elementView.id"
                        ></event-storming-attribute>
                    </v-card-text>
                </v-card>

                <v-card outlined>
                    <v-card-text>
                        <span class="headline">Operations</span>
                        <v-layout flat>
                            <v-col>
                                <draggable v-model="value.operations"
                                        v-bind="dragOptions"
                                        @start="drag = true"
                                        @end="drag = false"
                                >
                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                        <div v-for="(operation, idx) in value.operations" :key="idx">
                                            <v-row class="mb-6" no-gutters>
                                                <v-col cols="2">
                                                    <div>{{operation.class}}</div>
                                                </v-col>
                                                <v-col cols="3">
                                                    <div v-if="!operationEdit || value.operations.indexOf(operation) != operationEditIndex">
                                                        {{operation.returnType}}
                                                    </div>
                                                    <v-select class="mr-2 mt-0 pt-0"
                                                            v-else-if="operationEdit && value.operations.indexOf(operation) == operationEditIndex "
                                                            v-model="operation.returnType" 
                                                            :items="returnTypeList"
                                                            item-text="text" 
                                                            item-value="value"
                                                            item-disabled="disabled">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="4">
                                                    <div v-if="!operationEdit || value.operations.indexOf(operation) != operationEditIndex">
                                                        {{operation.name}}
                                                    </div>
                                                    <v-text-field class="mr-2 mt-0 pt-0"
                                                            v-else-if="operationEdit && value.operations.indexOf(operation) == operationEditIndex "
                                                            v-model="operation.name" 
                                                            required
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-btn  v-if="operationEdit && value.operations.indexOf(operation) == operationEditIndex "
                                                            x-small icon
                                                            class="mr-2"
                                                            @click="UMLOperationModify(operation)"
                                                    >
                                                        <v-icon>save</v-icon>
                                                    </v-btn>
                                                    <v-btn  v-else-if="!operationEdit || value.operations.indexOf(operation) != operationEditIndex"
                                                            x-small icon
                                                            class="mr-2"
                                                            @click="UMLOperationEdit(operation)"
                                                    >
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                    <v-btn  x-small icon
                                                            @click="UMLOperationDelete(operation)"
                                                    >
                                                        <v-icon>delete</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </transition-group>
                                </draggable>
                                <div>
                                    <v-row justify="center">
                                        <v-select 
                                                style="width: 40px;"
                                                v-model="operationReturnType" 
                                                :items="returnTypeList" 
                                                label="Return Type"
                                        ></v-select>
                                        <v-text-field 
                                                style="margin-right: 10px;"
                                                v-model="operationName" 
                                                label="Name"
                                                required
                                                v-on:keyup.enter="UMLOperationADD"
                                        ></v-text-field>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn  color="primary"
                                                        dark small fab
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        style="margin-top: 15px;"
                                                        @click="AddParam">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Add Parameters</span>
                                        </v-tooltip>
                                    </v-row>
                                    <v-row justify="center" v-for="(param, idx) in parameters" :key="idx">
                                        <v-select 
                                                style="width: 40px;"
                                                v-model="param.type"
                                                :items="returnTypeList" 
                                                label="Parameter Type"
                                        ></v-select>
                                        <v-text-field 
                                                style="margin-right: 10px;"
                                                v-model="param.name"
                                                label="Parameter Name"
                                        ></v-text-field>
                                        <v-btn  style="margin-top: 15px;"
                                                icon small 
                                                @click="DeleteParam(idx)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-row>
                                </div>
                                <v-row justify="end">
                                    <v-btn v-if="value.parentOperations.length > 0" 
                                            color="info" 
                                            depressed text
                                            @click="operationsDialog = true;"
                                    >Override</v-btn>
                                    <v-btn  depressed text
                                            style="color:#1E88E5;"
                                            @click="UMLOperationADD"
                                    >Add Operation</v-btn>
                                </v-row>
                            </v-col>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-list>

            <v-dialog v-model="operationsDialog" max-width="600">
                <v-card>
                    <v-card-title>Override Operations</v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-data-table
                                :headers="operationHeaders"
                                :items.sync="value.parentOperations"
                                hide-default-footer
                                class="elevation-1"
                                style="margin-bottom: 10px;">
                            <template v-slot:item.action="{ item }">
                                <v-row>
                                    <v-btn x-small outlined style="margin-right: 5px;" @click="updateOperation(item, 'override')">Override</v-btn>
                                    <!-- <v-btn x-small outlined @click="updateOperation(item, 'overload')">Overload</v-btn> -->
                                </v-row>
                            </template>
                        </v-data-table>

                        <v-row justify="center" v-if="addParameter">
                            <v-flex xs4>
                                <v-select
                                        v-model="operationReturnType" 
                                        :items="returnTypeList" 
                                        label="Return Type"
                                        style="margin-right: 15px;"
                                ></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                        v-model="operationName" 
                                        label="Name"
                                        style="margin-right: 15px;"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs1>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn  color="primary"
                                                dark small fab
                                                v-bind="attrs"
                                                v-on="on"
                                                style="margin-top: 15px;"
                                                @click="AddParam">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Add Parameters</span>
                                </v-tooltip>
                            </v-flex>
                        </v-row>
                        <v-row justify="center" v-for="(param, idx) in parameters" :key="idx">
                            <v-flex xs4>
                                <v-select 
                                        v-model="param.type"
                                        :items="returnTypeList" 
                                        label="Parameter Type"
                                        style="margin-right: 15px;"
                                ></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field 
                                        v-model="param.name"
                                        label="Parameter Name"
                                        style="margin-right: 15px;"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs1>
                                <v-btn icon style="margin-top: 15px;" @click="DeleteParam(idx)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-navigation-drawer>
    </v-layout>

</template>

<script>
    import draggable from 'vuedraggable'
    import UMLPropertyPanel from '../UMLPropertyPanel'

    var changeCase = require('change-case');
    var pluralize = require('pluralize');

    export default {
        mixins: [UMLPropertyPanel],
        name: 'uml-class-panel',
        components: {
            draggable,
        },
        data: function () {
            return {
                drag: false,
                
                // operations
                operationEdit: false,
                operationEditIndex: 0,

                returnTypeList: [ 'void', 'String', 'Long', 'Double', 'Boolean', 'Int', 'Byte', 'Float', 'Short' ],
                operationReturnType: 'void',
                
                operationName: '',
                parameters: [],
                isOverride: false,
                operationHeaders: [
                    {
                        text: 'Name',
                        value: 'name',
                        align: 'center'
                    },
                    {
                        text: 'Classifier',
                        value: 'class',
                        align: 'center'
                    },
                    {
                        text: 'Return Type',
                        value: 'returnType',
                        align: 'center'
                    },
                    {
                        text: '',
                        value: 'action',
                        sortable: false,
                        align: 'end'
                    },
                ],
                operationsDialog: false,
                addParameter: false,
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            titleName() {
                if(this.value.isVO) {
                    return "Value Object"
                } else {
                    return "Entity Class"
                }
            }
        },
        created: function () {
            var me = this
        },
        watch: {
            'value.name': {
                deep: true,
                handler(newVal, oldVal) {
                    var me = this;
                    if(newVal != oldVal) {
                        me.value.namePascalCase = changeCase.pascalCase(newVal);
                        me.value.nameCamelCase = changeCase.camelCase(newVal);
                        me.value.namePlural = pluralize(newVal);
                        Object.values(me.value.relations).forEach(function(item) {
                            if(item) {
                                if(item.to == me.value.elementView.id) {
                                    item.toName = newVal
                                    item.name = me.value.nameCamelCase
                                }
                                if(item.from == me.value.elementView.id) {
                                    item.fromName = newVal
                                }
                            }
                        })
                    }
                }
            },
            "value.isVO": function(val) {
                var me = this
                if(val) {
                    if (me.value.fieldDescriptors.length > 0) {
                        me.value.fieldDescriptors.forEach(function (item, idx) {
                            if(item.isKey) {
                                item.isKey = false
                            }
                        })
                    }
                    me.value._type = 'org.uengine.uml.model.vo.Class'
                } else {
                    if (me.value.fieldDescriptors.length > 0) {
                        var hasId = false
                        var idIdx = -1
                        me.value.fieldDescriptors.forEach(function (item, idx) {
                            if(item.isKey) {
                                hasId = true
                            }
                            if(item.name == 'id' && item.className == 'Long') {
                                hasId = true
                                idIdx = idx
                            }
                        })
                        if(!hasId) {
                            me.value.fieldDescriptors.push({
                                "_type": "org.uengine.uml.model.FieldDescriptor",
                                "name": "id",
                                "className": "Long",
                                "isKey": true,
                                "isVO": false,
                                "namePascalCase": "Long",
                                "nameCamelCase": "long",
                                "label": "- id: Long",
                                "isList": false,
                            })
                        } else {
                            if(idIdx >= 0) {
                                me.value.fieldDescriptors[idIdx].isKey = true
                            }
                        }
                    }
                    me.value._type = 'org.uengine.uml.model.Class'
                }
            },
        },
        methods:{
            UMLOperationADD() {
                var me = this
                var isNew = true
                if(!me.value.operations) {
                    me.value.operations = []
                } else if(me.value.operations.length > 0) {
                    me.value.operations.forEach(function(item) {
                        if(item.name == me.operationName) {
                            isNew = false
                        }
                    })
                }
                
                if(!isNew) {
                    return
                }

                var label = '+ ' + me.operationName + "("
                if(me.parameters.length > 0) {
                    me.parameters.forEach(function (param, index) {
                        label += param.name + ": " + param.type + ", "
                        if(index == me.parameters.length - 1) {
                            label = label.slice(0, -2)
                        }
                    })
                }
                label += "): " + me.operationReturnType
                var obj = {
                    "name": me.operationName,
                    "class": me.value.name,
                    "returnType": me.operationReturnType,
                    "parameters": me.parameters,
                    "label": label,
                    "isOverride": me.isOverride,
                }
                me.value.operations.push(obj)
                if(me.canvasbase.embedded) {
                    me._value.operations.push(obj)
                    me.$emit('_value-change', me._value)
                }

                me.operationReturnType = 'void'
                me.operationName = ''
                me.parameters = []
                me.isOverride = false
            },
            UMLOperationDelete(val) {
                var me = this;
                me.value.operations.forEach(function (operation, idx) {
                    if (operation.name == val.name && operation.type == val.type && operation.class == val.class) {
                        if (idx > -1) {
                            me.value.operations.splice(idx, 1)
                        }
                    }
                })
            },
            UMLOperationEdit(val) {
                var me = this
                me.operationEditIndex = me.value.operations.indexOf(val)
                me.operationEdit = true                
            },
            UMLOperationModify(val) {
                var me = this
                var label = "+ " + val.name + "("
                if(val.parameters.length > 0) {
                    val.parameters.forEach(function (param, index) {
                        label += param.name + ": " + param.type + ", "
                        if(index == val.parameters.length - 1) {
                            label = label.slice(0, -2)
                        }
                    })
                }
                label += "): " + val.returnType
                var tmpObject = {
                    "name": val.name,
                    "class": me.value.name,
                    "returnType": val.returnType,
                    "parameters": val.parameters,
                    "label": label,
                    "isOverride": val.isOverride,
                }

                me.value.operations[me.operationEditIndex] = tmpObject
                me.operationEdit = false
            },
            updateOperation(value, edit) {
                var me = this
                me.operationReturnType = value.returnType
                me.operationName = value.name
                
                if(edit == 'override') {
                    me.parameters = value.parameters
                    me.isOverride = true
                    me.UMLOperationADD()
                    me.operationsDialog = false;
                } else {
                    me.AddParam()
                }
            },
            AddParam() {
                var me = this;
                if(me.addParameter) {
                    me.parameters.push({
                        type: '',
                        name: ''
                    });
                } else {
                    me.addParameter = true;
                }
            },
            DeleteParam(index) {
                this.parameters.splice(index, 1)
            },
        },
    }
</script>
